export default __webpack_public_path__ + "static/media/fifaImage.9b1f13b9.jpg";